import React from 'react';
import { Edit2 } from 'react-feather';
import FocusAreaAccordion from './FocusAreaAccordion';
import IngredientCard from './IngredientCard';

const ComparisonFormulaCard = ({
  title, badge, ingredients, focusArea, focusAreaIcons, t, onSelect, isLoading,
  price, priceLabel, selectLabel, onEdit, isDisabled, allIngredients,
}) => (
  <section className="t-min-w-0">
    <header className="t-border-t-2 t-border-quiz-teal t-bg-navy/5 t-px-4 t-py-5 sm:t-px-5">
      <div className="t-grid t-grid-cols-1 t-gap-3 sm:t-grid-cols-2 sm:t-items-end">
        <div className="t-min-w-0">
          <p className="t-m-0 t-mb-1 t-text-[10px] t-font-bold t-uppercase t-text-quiz-teal">{badge}</p>
          <h2 className="t-m-0 t-font-serif t-text-2xl t-leading-tight t-text-navy">{title}</h2>
        </div>
        <div className="t-min-w-0 sm:t-text-right">
          <p className="t-m-0 t-mb-1 t-text-xs t-text-teal-muted">{priceLabel}</p>
          <p className="t-m-0 t-text-xl t-font-semibold t-leading-tight t-text-quiz-teal t-break-words">{price}</p>
        </div>
      </div>
    <div className="t-mt-5 t-flex t-flex-wrap t-items-center t-gap-3">
      <button type="button" onClick={onSelect} disabled={isLoading || isDisabled}
        className={`t-min-h-[44px] t-rounded-lg t-border t-border-quiz-teal t-px-4 t-py-2 t-text-sm t-font-semibold disabled:t-opacity-50 ${
          onEdit ? 't-bg-quiz-teal t-text-white hover:t-opacity-90' : 't-bg-white t-text-quiz-teal hover:t-bg-teal-bg'
        }`}>
        {isLoading ? t('QuizComparison_Saving') : selectLabel}
      </button>
      {onEdit && <button type="button" onClick={onEdit} disabled={isLoading}
        className="t-inline-flex t-min-h-[44px] t-items-center t-gap-2 t-border-0 t-bg-transparent t-px-2 t-py-2 t-text-sm t-font-semibold t-text-quiz-teal hover:t-underline">
        <Edit2 size={16} aria-hidden="true" />{t('QuizComparison_Edit')}
      </button>}
    </div>
    </header>
    <div className="t-mt-5 t-mb-4">
      <FocusAreaAccordion focusArea={focusArea} focusAreaIcons={focusAreaIcons} collapsedCount={3} />
    </div>
    <p className="!t-m-0 t-my-5 t-text-sm t-text-teal-muted">
      {t('QuizComparison_IngredientCount', { count: ingredients.length })}
    </p>
    <div className="t-pt-2 t-pb-1">
      <div className="t-flex t-items-center t-gap-3 t-px-3 t-pb-1">
        <div className="t-w-2.5" />
        <div className="t-flex-1" />
        <div className="t-flex t-items-center t-gap-2 t-flex-shrink-0">
          <span className="t-text-[10px] t-font-bold t-text-navy/40 t-uppercase t-tracking-wider t-min-w-[44px] t-text-right">
            {t('Quantity')}
          </span>
          <span className="t-text-[10px] t-font-bold t-text-navy/40 t-uppercase t-tracking-wider t-min-w-[28px] t-text-right">
            %NRV
          </span>
          <span className="t-w-2.5" />
        </div>
      </div>
      {ingredients.map((item, index) => {
        const ingredientData = allIngredients?.data?.find(
          (ingredient) => Number(ingredient.id) === Number(item.ingredient_id),
        );
        return <IngredientCard
          key={item.ingredient_id || index}
          item={item}
          index={index}
          ingredientData={ingredientData}
          defaultOpen={index === 0}
        />;
      })}
    </div>
  </section>
);

export default ComparisonFormulaCard;
